import axiosInstance from "./http";

// Fetch all active users other than the user who created the care plan if care plan provided
export const fetchActiveUsersService = async (care_plan_id) => {
  const response = await axiosInstance.get(
    `/users/active?care_plan_id=${care_plan_id}`
  );
  return response.data;
};

export const fetchUsersService = async (
  page,
  rowsPerPage,
  searchQuery,
  ordering = ""
) => {
  const { name, email } = searchQuery || {}; // for search draft care plan
  const params = {
    page,
    page_size: rowsPerPage,
  };
  if (name) params.name = name;
  if (email) params.email = email;
  if (ordering) params.ordering = ordering;

  try {
    const response = await axiosInstance.get("/users/", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchMdtRolesService = async (userData) => {
  try {
    const response = await axiosInstance.get("users/mdt-roles/");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createUserService = async (userData) => {
  // If sending a file (avatar), we typically use multipart form data
  let formData = new FormData();

  // userData is e.g. { name, email, is_active_officer, is_admin, mdt_roles, avatarFile? }
  for (const key in userData) {
    if (key === "avatarFile" && userData.avatarFile instanceof File) {
      formData.append("profile_picture", userData.avatarFile);
    } else if (key === "mdt_roles") {
      // If it's an array of IDs
      userData.mdt_roles.forEach((roleId) => {
        formData.append("mdt_roles", roleId);
      });
    } else {
      formData.append(key, userData[key]);
    }
  }
  try {
    const response = await axiosInstance.post("/users/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUserService = async (userId) => {
  try {
    await axiosInstance.delete(`/users/${userId}/`);
    return userId;
  } catch (error) {
    throw error;
  }
};

export const updateUserService = async (userId, userData) => {
  // If sending a file (avatar), we typically use multipart form data
  let formData = new FormData();

  // userData is e.g. { name, email, is_active_officer, is_admin, mdt_roles, avatarFile? }
  for (const key in userData) {
    if (key === "avatarFile" && userData.avatarFile instanceof File) {
      formData.append("profile_picture", userData.avatarFile);
    } else if (key === "mdt_roles") {
      // If it's an array of IDs
      userData.mdt_roles.forEach((roleId) => {
        formData.append("mdt_roles", roleId);
      });
    } else if (
      key === "remove_profile_picture" &&
      userData.remove_profile_picture
    ) {
      // Mark removal
      formData.append("remove_profile_picture", "true");
    } else {
      formData.append(key, userData[key]);
    }
  }

  try {
    const response = await axiosInstance.patch(`/users/${userId}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const generatePasswordResetLink = async (userId) => {
  try {
    const response = await axiosInstance.post("generate-password-reset-link/", {
      user_id: userId,
    });
    return response.data; // { reset_link: ... }
  } catch (error) {
    throw error;
  }
};

export const fetchCarePlanMdtUsersService = async ({
  carePlanId,
  assignedPage,
  assignedRowsPerPage,
  unassignedPage,
  unassignedRowsPerPage,
  search = "",
  ordering = "",
}) => {
  const params = {
    assigned_page: assignedPage,
    assigned_page_size: assignedRowsPerPage,
    unassigned_page: unassignedPage,
    unassigned_page_size: unassignedRowsPerPage,
  };
  if (search) params.search = search;
  if (ordering) params.ordering = ordering;

  const { data } = await axiosInstance.get(
    `/careplans/${carePlanId}/mdt-users/`,
    { params }
  );
  return data;
};
